/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup'
import {i18n} from '@/setup/i18n-setup'

import {
  CREATE_PASSWORD_DUMMY_STUDENT_APP,
  CREATE_USER,
  DELETE_USER,
  GET_STUDENT,
  GET_STUDENTS,
  GET_USER,
  GET_USERS,
  GET_USER_OPTIONS,
  RESET_PASSWORD,
  UPDATE_USER,
} from '@/queries/modules/user'

import {
  addItemSuccess,
  deleteItemSuccess,
  error,
  serverResponseStatusCustom,
  updateItemSuccess,
} from '@/utils/notification'


export async function getUser(context, payload) {
  // console.log('Get User...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_USER,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setUser', data.getUser)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getUsers(context) {
  // console.log('Get Users...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_USERS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setUsers', data.getUsers)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function createUser(context, payload) {
  // console.log('Add User...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_USER,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('setSuccess', addItemSuccess({}))

    setTimeout(() => {
      vm.$router.push(payload.redirect)
    }, 200);
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function updateUser(context, payload) {
  // console.log('Create User...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const vm = payload.vm
  const variables = {
    id: payload.id,
    payload: payload.form
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: UPDATE_USER,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.dispatch('getNavMenuItems', null, {root: true})
    context.dispatch('getPermissions', null, {root: true})
    context.commit('setSuccess', updateItemSuccess({}))

    setTimeout(() => {
      vm.$router.push(payload.redirect)
    }, 200);
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function resetPassword(context, payload) {
  // console.log('Reset Password...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: RESET_PASSWORD,
        variables
      })

    const {data} = await response
    const OTP = data.resetPassword.oneTimePassword;
    context.commit('setResetPassword', data.resetPassword)
    context.commit('setSuccess', serverResponseStatusCustom(i18n.t('notification.reset-password-success-title'), {
      status: {
        success: true,
        error: false,
        message: `${i18n.t('notification.reset-password-success-message')} ${OTP}`
      }
    }))
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function deleteUser(context, payload) {
  // console.log('Delete User...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_USER,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    const {deleteUser} = data
    context.commit('delUser', deleteUser)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function getStudent(context, payload) {
  // console.log('Get Student...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }
  try {
    const response = await apolloClient
      .query({
        query: GET_STUDENT,
        variables,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setStudent', data.getStudent)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function getStudents(context) {
  // console.log('Get Users...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_STUDENTS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    context.commit('setStudents', data.getStudents)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(e.toString(), null));
  }
}

export async function deleteStudent(context, payload) {
  // console.log('Delete User...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {
      id: payload.form.id
    }

    const response = await apolloClient
      .mutate({
        mutation: DELETE_USER,
        variables,
        fetchPolicy: 'no-cache'
      })
    const {data} = await response
    context.commit('delStudent', data.deleteUser)
    context.commit('setSuccess', deleteItemSuccess({}))

  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function resetStudentPassword(context, payload) {
  // console.log('Reset Password...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: RESET_PASSWORD,
        variables
      })

    const {data} = await response
    const OTP = data.resetPassword.oneTimePassword;
    context.commit('setResetStudentPassword', data.resetPassword)
    context.commit('setSuccess', serverResponseStatusCustom(i18n.t('notification.reset-password-success-title'), {
      status: {
        success: true,
        error: false,
        message: `${i18n.t('notification.reset-password-success-message')} ${OTP}`
      }
    }))
  } catch (e) {
    // console.log(e)
    context.commit('setError', error(null, null))
  }
}

export async function createPasswordDummyStudentApp(context, payload) {
  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    id: payload.form.id
  }

  try {
    const response = await apolloClient
      .mutate({
        mutation: CREATE_PASSWORD_DUMMY_STUDENT_APP,
        variables
      })

    const {data} = await response
    context.commit('setSuccess', null)
    return data.createPasswordDummyStudentApp
  } catch (e) {
    context.commit('setError', error(null, null))
    return null
  }
}

export async function getUserOptions(context) {
  // console.log('Get Users...')

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_USER_OPTIONS,
        fetchPolicy: 'network-only'
      })
    const {data} = await response
    const {getUsers: users} = data
    // console.log(users)

    context.commit('setUsers', users)
    context.commit('setSuccess', null)
  } catch (e) {
    // console.log(e);
    context.commit('setError', error(e.toString(), null))
  }
}
